<template>
  <div
    id="app"
    style="height:100%"
  >
    <router-view />
  </div>
</template>

<script>
  import createPopup from '@/utils/popup-fun/index.js';
  import develop from '@/components/develop-person/index.vue';
  import mock from '@/components/develop-person/mock.vue';

  export default {
    name: 'app',
    data() {
      return {
        code: '',
        code1: '',
      };
    },
    mounted() {

      if (process.env.NODE_ENV == 'development') {
        document.onkeyup = (evn) => {
          if (this.code && this.code1) return;
          let key = evn.keyCode || evn.which || evn.charCode;
          if (key == 17) {
            evn.preventDefault();
            this.code = 17;
          }
          if (key == 18) {
            evn.preventDefault();
            this.code1 = 18;
          }
          if (key == 118) {
            createPopup(mock);
            evn.preventDefault();
          }
          if (this.code && this.code1) {
            createPopup(develop).then(res => {
              location.reload();
            }).catch(() => {
              this.code = '';
              this.code1 = '';
            });
          }
          console.log(key, /key/);
          console.log(develop, /develop/);

        };
      }
    }
  };
</script>

<style>
  /* 防止table表格控件表头与内容列不对齐 */
  body .el-table th.gutter {
    display: block !important;
  }
  body .el-table colgroup.gutter {
    display: block !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue